import React from 'react';

import { useTranslation } from 'react-i18next';

import { ChevronIcon } from '@icons';

import { PromotionWinnerType } from '@types';

import { WinnerRow } from './winner-row';
import * as Styled from './winner-table.styled';

interface PaginationStepType {
	start: number;
	end: number;
}

const handlePaginationAmount = (length: number) => {
	if (length < 3) {
		return [0];
	}

	let tmpArray: number[] = [];

	for (let i = 0; i < Math.ceil(length / 3); i++) {
		tmpArray.push(i + 1);
	}

	return tmpArray;
};

type OwnProps = {
	winners: PromotionWinnerType[];
	isAll?: boolean;
	winnerUser?: PromotionWinnerType | null;
};

const WinnerTable: React.FC<OwnProps> = ({ winners, isAll, winnerUser }) => {
	const { t } = useTranslation('main');

	const paginationAmount: number[] = handlePaginationAmount(winners.length - (isAll ? 0 : 3));

	const [currentPage, setCurrentPage] = React.useState<number>(1);

	const [paginationStep, setPaginationStep] = React.useState<PaginationStepType>({
		start: 0,
		end: 5
	});

	const handlePageDecrease = () => {
		if (paginationStep.start <= 5) {
			setPaginationStep({
				start: 0,
				end: 5
			});
		} else {
			setPaginationStep({
				start: paginationStep.start - 6,
				end: paginationStep.start
			});
		}
	};

	const handlePageIncrease = () => {
		if (paginationStep.end >= paginationAmount.length) {
			return;
		} else {
			setPaginationStep({
				start: paginationStep.end,
				end: paginationStep.end + 6
			});
		}
	};

	return (
		<Styled.Wrapper>
			<Styled.HeaderRow>
				<Styled.HeaderPlace>{t('place')}</Styled.HeaderPlace>
				<Styled.HeaderParticipant>{t('participants')}</Styled.HeaderParticipant>
				<Styled.HeaderPrize>{t('prizes')}</Styled.HeaderPrize>
			</Styled.HeaderRow>
			<Styled.WinnerTable>
				{winnerUser && <WinnerRow isHighlight winner={winnerUser} />}
				{winners.slice((isAll ? 0 : 3) * currentPage, (isAll ? 0 : 3) * currentPage + 3).map(winner => (
					<WinnerRow key={winner.position} winner={winner} />
				))}
			</Styled.WinnerTable>
			{paginationAmount.length > 1 && (
				<Styled.PaginationRow>
					<Styled.PaginationButtonsRow>
						{paginationStep.start !== 0 && (
							<Styled.PaginationButton onClick={handlePageDecrease}>
								<ChevronIcon />
							</Styled.PaginationButton>
						)}
						{paginationAmount.slice(paginationStep.start, paginationStep.end).map(page => (
							<Styled.PaginationButton onClick={() => setCurrentPage(page)} $isActive={page === currentPage} key={page}>
								{page}
							</Styled.PaginationButton>
						))}
						{paginationStep.end < paginationAmount.length && (
							<Styled.PaginationButton onClick={handlePageIncrease}>
								<ChevronIcon.Right />
							</Styled.PaginationButton>
						)}
					</Styled.PaginationButtonsRow>
				</Styled.PaginationRow>
			)}
		</Styled.Wrapper>
	);
};

export default WinnerTable;
